export function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.substring(1);
}
